import { DropboxFolderType } from '@account/types';
import { RepairFiles } from '@assets/icons/RepairFiles';
import { palette } from '@constants/theme';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import MemoryIcon from '@mui/icons-material/Memory';
import { IntlShape } from 'react-intl';

export const hasMinCharacters = (password: string, minLength: number = 10) => {
    return password.length >= minLength;
};

export const hasNumber = (password: string) => {
    return /\d/.test(password);
};

export const hasUpperCase = (password: string) => {
    return /[A-Z]/.test(password);
};

export const hasSpecialCharacter = (password: string) => {
    return /[!@#$%^&*(),.?":{}|<>_+\-;'=\[\]]/.test(password);
};

export const validatePassword = (password: string, { formatMessage }: IntlShape, minLength: number = 10) => [
    {
        isValid: hasMinCharacters(password, minLength),
        label: formatMessage(
            {
                id: 'account.security.passwordRequirements.minCharacters',
                defaultMessage: `{min}+ characters`,
            },
            { min: minLength }
        ),
    },
    {
        isValid: hasNumber(password),
        label: formatMessage(
            {
                id: 'account.security.passwordRequirements.number',
                defaultMessage: `Number`,
            },
            { min: minLength }
        ),
    },
    {
        isValid: hasSpecialCharacter(password),
        label: formatMessage(
            {
                id: 'account.security.passwordRequirements.specialCharacter',
                defaultMessage: `Special character`,
            },
            { min: minLength }
        ),
    },
    {
        isValid: hasUpperCase(password),
        label: formatMessage(
            {
                id: 'account.security.passwordRequirements.upperCase',
                defaultMessage: `Uppercase character`,
            },
            { min: minLength }
        ),
    },
];

export const getFolderTypeInfo = (intl: IntlShape, folderType: DropboxFolderType) => {
    switch (folderType) {
        case DropboxFolderType.Repairs:
            return {
                title: intl.formatMessage({
                    id: 'account.connections.repairFiles.title',
                    defaultMessage: 'Repair Files',
                }),
                icon: <RepairFiles fill={`#${palette['primary-600']}`} />,
            };
        case DropboxFolderType.Manuals:
            return {
                title: intl.formatMessage({ id: 'account.connections.manuals.title', defaultMessage: 'Manuals' }),
                icon: <AutoStoriesOutlinedIcon sx={{ fontSize: 30 }} color="primary" />,
            };
        case DropboxFolderType.Firmwares:
            return {
                title: intl.formatMessage({
                    id: 'account.connections.firmwareFiles.title',
                    defaultMessage: 'Firmware Files',
                }),
                icon: <MemoryIcon sx={{ fontSize: 30 }} color="primary" />,
            };
    }
};
